import { Location } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MarsDebatesService } from './mars-debates.service';
import { MarsDebatesListService } from './mars-debates-list.service';
import { EmitterService } from 'core/services/emitter.service';

@Component({
  selector: 'lms-mars-debates',
  templateUrl: './mars-debates.component.html',
  styleUrls: ['./mars-debates.component.scss'],
  providers: [MarsDebatesListService]
})
export class MarsDebatesComponent implements OnInit {
  @Input() listId: string;
  @Input() group: any;

  public viewModes = {
    debates: 'debates',
    detail: 'detail'
  };
  public view = this.viewModes.debates;
  public toolbarConfig: any;
  public dataSource: any;
  public stats: any;
  public selectedDebate: any;

  constructor(
    public route: ActivatedRoute,
    public location: Location,
    public debatesService: MarsDebatesService,
    public debatesListService: MarsDebatesListService,
    public translate: TranslateService
  ) {}

  async ngOnInit(): Promise<void> {
    const options = {
      filters: {
        groupId: this.group.id
      }
    };
    this.dataSource = await this.debatesListService.getDatasource(this.listId, options);

    this.toolbarConfig = {
      list: {
        listId: this.listId,
        columnChooser: false,
        download: false,
        filterRow: false,
        hidePrint: true,
        skeletor: true
      }
    };
    this.debatesService.getDebatesStats({ groupId: this.group.id }).subscribe((stats) => {
      this.stats = stats;
    });

    EmitterService.get('editMarsDebate').subscribe((debate) => {
      this.editDebate(debate);
    });
  }

  changeView(newView) {
    this.view = newView;
  }

  editDebate(debate?: any) {
    this.selectedDebate = debate;
    this.changeView(debate ? this.viewModes.detail : this.viewModes.debates);
  }

  onDebateUpdated(debate) {
    this.dataSource.refreshData({});
  }
}
